import Breadcrumbs from "../components/ui/Breadcrumbs";

const breadcrumbs = [
  { label: "Terms of Service", link: "/terms-of-service" },
];

const TermsOfService = () => {

  return (
    <section className="color-swap-container full-width flex flex-col gap-10 items-center pt-5 md:pt-10">

      <div className="flex flex-col gap-10 contained-width">
        <Breadcrumbs items={breadcrumbs} />
        <div className="flex flex-col gap-5 items-center pb-0 pt-5">
          <h3 className="text-center">Terms of Service</h3>
          <p className="text-sm text-gray-500">Effective Date: April 1, 2025</p>
        </div>
      </div>

      <div className="contained-width">
        <p>Welcome to Treatink, LLC ("Company," "we," "us," or "our"). These Terms of Service ("Terms") govern your use of our website, <a href="https://treatink.com">https://treatink.com</a> (the "Website"), and any related services provided by Treatink, LLC. By accessing or using our Website, you agree to comply with and be bound by these Terms. If you do not agree with these Terms, please do not use our Website.</p>
        <h5>1. Use of the Website</h5>
        <ul style={{ paddingLeft: '20px', listStyle: 'initial' }}>
          <li>You must be at least 18 years old to use this Website.</li>
          <li>You agree to use the Website only for lawful purposes.</li>
          <li>We reserve the right to refuse service, terminate accounts, or cancel orders at our discretion.</li>
        </ul>
        <br />
        <br />

        <h5>2. Products and Orders</h5>
        <ul style={{ paddingLeft: '20px', listStyle: 'initial' }}>
          <li>All product descriptions, pricing, and availability are subject to change without notice.</li>
          <li>We strive to display our products as accurately as possible, but we do not guarantee that colors, images, or descriptions are error-free.</li>
          <li>We reserve the right to refuse or cancel any order for any reason, including suspected fraud.</li>
        </ul>
        <br />
        <br />

        <h5>3. Payment and Billing</h5>
        <ul style={{ paddingLeft: '20px', listStyle: 'initial' }}>
          <li>All payments must be made through the available payment methods.</li>
          <li>You agree to provide accurate billing and payment information.</li>
        </ul>
        <br />
        <br />

        <h5>4. Shipping and Returns</h5>
        <ul style={{ paddingLeft: '20px', listStyle: 'initial' }}>
          <li>Shipping times and costs vary based on location.</li>
          <li>We are not responsible for lost, stolen, or delayed shipments.</li>
          <li>Refer to our return policy on the Website.</li>
        </ul>
        <br />
        <br />

        <h5>5. Intellectual Property</h5>
        <p>All content on this Website is the property of Treatink, LLC or its licensors and is protected by copyright and trademark laws.</p>
        <br />

        <h5>6. User Accounts</h5>
        <p>If you create an account, you are responsible for maintaining its security and notifying us of any unauthorized access.</p>
        <br />

        <h5>7. Limitation of Liability</h5>
        <p>We are not liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of the Website.</p>
        <br />

        <h5>8. Indemnification</h5>
        <p>You agree to indemnify and hold harmless Treatink, LLC from any claims arising from your use of the Website.</p>
        <br />

        <h5>9. Governing Law</h5>
        <p>These Terms are governed by the laws of the State of Florida. Any disputes shall be resolved in the courts of Hillsborough County, Florida.</p>
        <br />

        <h5>10. Changes to These Terms</h5>
        <p>We reserve the right to update these Terms at any time.</p>
        <br />

        <h5>11. Contact Information</h5>
        <p>
          <strong>Treatink, LLC</strong><br />
          PO Box 550<br />
          Odessa, FL 33556<br />
          Phone: <a className="color-secondary underline" href="tel:(888) 890-0969">(888) 890-0969</a><br />
          Email: <a className="color-secondary underline" href="mailto:support@treatink.com">support@treatink.com</a>
        </p>
      </div>

    </section >
  );
};

export default TermsOfService;
